import { IStatusAction, IPendingItem, ADD_PENDING, COMPLETE_PENDING } from "./types";

export function addPending(item: IPendingItem): IStatusAction {
  return {
    type: ADD_PENDING,
    item: item,
  };
}

export function completePending(item: IPendingItem): IStatusAction {
  return {
    type: COMPLETE_PENDING,
    item: item,
  };
}
